import { useNavigate } from "react-router-dom";
import Leaderboard from "./ai-tips-chat";

export default function TodaysTips() {
  const navigate = useNavigate();

  // Make React Router's navigate function available globally
  // to be used by components that need it but can't access the hook directly
  window.navigate = navigate;

  // Also store the router for client-side navigation
  window.clientSideRouter = { navigate };

  return <Leaderboard />;
}
